import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type PageShellSize = 'default' | 'narrow' | 'play' | 'full'
type PageShellGap = '4' | '6' | '8' | '10'

const maxWidthClass: Record<PageShellSize, string> = {
	default: 'max-w-[1600px]',
	narrow: 'max-w-[760px]',
	play: 'max-w-[1280px]',
	full: 'max-w-none',
}

const gapClass: Record<PageShellGap, string> = {
	'4': 'gap-4',
	'6': 'gap-6',
	'8': 'gap-8',
	'10': 'gap-10',
}

interface PageShellProps {
	children: ReactNode
	footer?: ReactNode
	size?: PageShellSize
	gap?: PageShellGap
	className?: string
	centered?: boolean
}

export function PageShell({ children, footer, size = 'default', gap = '4', className, centered = false }: PageShellProps) {
	return (
		<div className={cn('flex w-full min-w-0 flex-col', className)}>
			<div
				className={cn(
					'mx-auto flex w-full min-w-0 flex-col px-4 py-6 sm:px-6 lg:px-0',
					maxWidthClass[size],
					gapClass[gap],
					centered && 'items-center justify-center text-center',
				)}
			>
				{children}
			</div>
			{footer ? <div className='mx-auto w-full min-w-0 max-w-[1600px] px-4 pb-6 sm:px-6 lg:px-0'>{footer}</div> : null}
		</div>
	)
}
